/**
 * ListItem Molecule Component
 * List item with icon and content for process steps, insights, etc.
 */

import React from 'react';
import { storyblokEditable } from '@/lib/blocks';
import { Heading } from '@/components/atoms/Heading';
import { Text } from '@/components/atoms/Text';
import { Icon } from '@/components/atoms/Icon';
import type { ListItemBlok } from '@/types';

export interface ListItemProps {
  blok: ListItemBlok;
  className?: string;
}

export const ListItem: React.FC<ListItemProps> = ({ blok, className = '' }) => {
  const { icon_type = 'checkbox', title, description } = blok;

  // Icon rendering based on type
  const renderIcon = () => {
    switch (icon_type) {
      case 'checkbox':
        return <Icon name="check" size="sm" className="text-primary" />;
      case 'bullet':
        return <span className="w-2 h-2 rounded-full bg-primary" />;
      case 'number':
        return null; // Number will be added externally if needed
      default:
        return <Icon name="check" size="sm" className="text-primary" />;
    }
  };

  return (
    <div {...storyblokEditable(blok)} className={`flex items-start gap-3 ${className}`}>
      {icon_type !== 'number' && (
        <div className="flex items-center justify-center w-5 h-5 mt-0.5 flex-shrink-0">
          {renderIcon()}
        </div>
      )}
      <div className="flex-1">
        <Heading level="h5" className="text-base font-bold">
          {title}
        </Heading>
        {description && (
          <Text className="text-sm text-gray-700 mt-1">
            {description}
          </Text>
        )}
      </div>
    </div>
  );
};

export default ListItem;
